import { categoryColumnOptions } from "./dataExample/categoryColumnOptions";
import { Tag, Typography, Space } from "antd";
import { useTranslation } from "react-i18next";
import React from "react";

const { Title, Text } = Typography;

export default function CategoryGuide(): React.ReactElement {
  const { t } = useTranslation();

  const basicFields = categoryColumnOptions.filter(col => col.category === "basic");

  const renderColumnCard = (column: (typeof categoryColumnOptions)[0], index: number) => (
    <div key={index} className="column-card">
      <Space direction="vertical" size={4} className="column-space">
        <div className="column-header">
          <Text className="column-field-name">{column.field}</Text>
          {column.required && (
            <Tag color="red" className="required-tag">
              {t("Required")}
            </Tag>
          )}
        </div>
        <Text type="secondary" className="column-description">
          {t(column.description)} • <Text italic>{column.example}</Text>
        </Text>
      </Space>
    </div>
  );

  return (
    <div className="client-info-guide">
      <Space direction="vertical" size="middle" className="guide-space">
        <div>{basicFields.map((col, idx) => renderColumnCard(col, idx))}</div>

        <div className="notes-section">
          <Title level={5} className="notes-title">
            {t("Important Notes")}
          </Title>
          <Space direction="vertical" size={2}>
            <Text className="note-text">
              • {t("All column headers must be in French exactly as shown above")}
            </Text>
            <Text className="note-text">
              • {t("The file must be in .xlsx, .xls, or .csv format")}
            </Text>
            <Text className="note-text">• {t("Maximum 2000 lines per file")}</Text>
            <Text className="note-text">
              • {t("Empty cells are allowed for non-required fields")}
            </Text>
            <Text className="note-text">
              • {t("Download the model file for a template with all available columns")}
            </Text>
          </Space>
        </div>
      </Space>
    </div>
  );
}
